import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import cn from 'classnames';

import { actions as editPaymentActions } from '../../../../redux/healthboard/requests/edit-payment-req';
import { loggedUserIdSelector } from '../../../../redux/context/selectors';
import AmountInput from '../../../common/AmountInput';
import EditBtn from '../../../Button/EditBtn';
import TransactionInfo from '../TransactionInfo';
import Button from '../../../Button';
import { usePaymentAmountData } from './usePaymentAmountData';
import { amountFieldProps } from './field';
import styles from './index.styl';

export function PaymentAmountField({
  formatMessage,
  value,
  isPaid,
  isUpcoming,
  appointmentId,
  onlyEditMode = false,
  onClose,
  appointment,
}) {
  const titleAmount = formatMessage({
    id: 'appointment.details.paymentAmount.title',
  });

  const labelPaymentAmount = formatMessage({
    id: 'virtualVisit.details.paymentAmount',
  });

  const canEditCopay = get(appointment, 'canEditCopay', false);

  const loggedUserId = useSelector(loggedUserIdSelector);
  const dispatch = useDispatch();

  const {
    editMode,
    errorState,
    handleCopayChange,
    handleToInitialState,
    handleToggleEditState,
    safeValue,
    isPristine,
    currentValue,
  } = usePaymentAmountData(formatMessage, value, appointmentId);

  const handleSubmit = () => {
    dispatch(
      editPaymentActions.send({
        userId: loggedUserId,
        appointmentId,
        copay: currentValue,
      }),
    );
    handleToInitialState();
  };

  return (
    <div className={styles.root}>
      {!onlyEditMode && (
        <div className={styles.paymentTitleWrapper}>
          <div className={styles.paymentTitle}>{titleAmount}</div>
          {!isPaid && isUpcoming && canEditCopay && (
            <div className={styles.paymentEditButton}>
              <EditBtn onClick={handleToggleEditState} />
            </div>
          )}
          {isPaid && (
            <div className={styles.paymentInfo}>
              <TransactionInfo
                appointment={appointment}
                formatMessage={formatMessage}
              />
            </div>
          )}
        </div>
      )}
      {editMode || onlyEditMode ? (
        <Fragment>
          <AmountInput
            {...amountFieldProps(formatMessage)}
            name="paymentAmountInput"
            value={safeValue}
            onChange={handleCopayChange}
            label={onlyEditMode && labelPaymentAmount}
          />
          <Button
            className={cn(styles.paymentButton, {
              [styles.paymentButtonInDashboard]: onlyEditMode,
            })}
            raised
            color="primary"
            onClick={handleSubmit}
            disabled={errorState || isPristine}
          >
            {formatMessage({ id: 'common.save' })}
          </Button>

          <Button
            className={cn(styles.paymentButton, {
              [styles.paymentButtonInDashboard]: onlyEditMode,
            })}
            raised
            color="accent"
            onClick={onClose || handleToInitialState}
          >
            {formatMessage({ id: 'common.cancel' })}
          </Button>
        </Fragment>
      ) : (
        <div className={styles.paymentAmountInput}>{safeValue}</div>
      )}
    </div>
  );
}

PaymentAmountField.propTypes = {
  formatMessage: PropTypes.func,
  value: PropTypes.number,
  isPaid: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  appointmentId: PropTypes.number,
  onlyEditMode: PropTypes.bool,
  onClose: PropTypes.func,
  appointment: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/PaymentAmountField/index.jsx